import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getPorcentajeSalEntAction } from '../Redux/dash/actions/getPorcentajeSalEntAction'

const useDashPorcentaje = q => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getPorcentajeSalEntAction(q))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q])
}

export default useDashPorcentaje
